import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import FormErrorMessage from '../../../../../atoms/FormErrorMessage';

export enum ErrorType {
  Blank = 'blank',
  Failed = 'failed',
  Taken = 'taken',
  Invalid = 'invalid',
}

const BlankMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.createUser.blank`,
        defaultMessage: intl.formatMessage({ id: 'books.errors.blank' }),
      })}
    </FormErrorMessage>
  );
};

const TakenMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.createUser.taken`,
        defaultMessage: intl.formatMessage({ id: 'books.errors.taken' }),
      })}
    </FormErrorMessage>
  );
};

const InvalidMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.createUser.invalid`,
        defaultMessage: intl.formatMessage({
          id: 'books.errors.invalid',
        }),
      })}
    </FormErrorMessage>
  );
};

const ERROR_COMPONENTS: {
  [error in ErrorType]: React.FC | undefined;
} = {
  [ErrorType.Blank]: BlankMessage,
  [ErrorType.Taken]: TakenMessage,
  [ErrorType.Invalid]: InvalidMessage,
  [ErrorType.Failed]: undefined,
};

interface Props {
  errors?: ErrorType[];
}

const InputBookingWaitingListErrorMessage: FC<Props> = (props) => {
  const { errors } = props;

  if (!errors) return null;
  if (errors.length === 0) return null;

  return (
    <>
      {errors.map((error, index) => {
        const Component = ERROR_COMPONENTS[error];
        if (!Component) {
          return null;
        }
        return <Component key={index} />;
      })}
    </>
  );
};

export default InputBookingWaitingListErrorMessage;
